/* The switch that covers the figures, and uncovers them again.
 *
 * It started in the header, which only four screens have — so hiding the book
 * on the Value tab and then opening a position left no way back short of
 * finding Settings, on a screen whose numbers were all dots. A switch you can
 * reach in one direction and not the other is a trap, not a switch. So it lives
 * here and goes in every screen's top bar.
 *
 * The eye is drawn rather than pulled from an icon font, the same as everything
 * else in this app, and the crossed-out state is the pressed one — the button
 * shows what is true now, not what tapping would do. */

import { useStore } from '../state/store';

/** `push` puts it hard right. Leave it off in a bar that already has something
    pushed right — two auto margins split the free space between them and strand
    whatever was there in the middle. */
export function HideToggle({ push = false }: { push?: boolean }) {
  const { state, saveSettings } = useStore();
  const hidden = state.settings.hideAmounts === true;

  return (
    <button
      className="hide-btn"
      aria-pressed={hidden}
      aria-label={hidden ? 'Show amounts' : 'Hide amounts'}
      style={push ? { marginLeft: 'auto' } : undefined}
      onClick={() => void saveSettings({ hideAmounts: !hidden })}
    >
      <svg viewBox="0 0 20 14" width="17" height="12" aria-hidden="true" fill="none"
           stroke="currentColor" strokeWidth="1.4">
        <path d="M1.2 7S4.4 1.9 10 1.9 18.8 7 18.8 7 15.6 12.1 10 12.1 1.2 7 1.2 7Z" />
        <circle cx="10" cy="7" r="2.2" />
        {hidden ? <path d="M3.4 12.6 16.6 1.4" strokeLinecap="round" /> : null}
      </svg>
    </button>
  );
}
